import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { checkAuth } from "../../api/axios";
import CenteredLoader from "../CenteredLoader";

const PrivateRoute: React.FC = () => {
  const [isAuth, setIsAuth] = useState<boolean | null>(null);

  useEffect(() => {
    async function verify() {
      const authenticated = await checkAuth();
      setIsAuth(authenticated);
    }
    verify();
  }, []);

  if (isAuth === null) {
    return <CenteredLoader />;
  }

  return isAuth ? <Navigate to="/dashboard" /> : <Outlet />;
};

export default PrivateRoute;
